import styled, {css} from "styled-components";
import {styles} from "../../../../config";

export const BottomProposalContainer = styled.div`
    position: absolute;
    padding: 0;
    text-align: center;
    line-height: 30px;
    vertical-align: middle;
    background-color: #FFFFFF;
    bottom: 0;
    font-weight: 500;
    font-size: 14px;
    z-index: 1;
    width: 100%;
`;

const proposalETARowPadding = `6px`;

export const ProposalETARow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const proposalIconTopBottomMargin = `15px`;

export const BottomProposalIcon = styled.img`
    padding-left: ${proposalETARowPadding};
    padding-right: ${proposalETARowPadding};
    margin-top: ${proposalIconTopBottomMargin};
    margin-bottom: ${proposalIconTopBottomMargin};
`;

const BottomProposalLabel = css`
    line-height: 100%;
    padding-top: 17px;
`;

export const ProposalETA = styled.label`
    ${BottomProposalLabel};
    padding-left: ${proposalETARowPadding};
    padding-right: ${proposalETARowPadding};
    margin: 0;
    font-weight: 600;
    font-size: 15px;
    color: #545454;
`;

export const ProposalAcceptButton = styled.div`
    background-color: ${styles.primaryColor};
    height: 51px;
    width: calc(100% - 20px);
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 12px;
`;

export const ProposalAcceptButtonLabel = styled.label`
    color: rgb(255, 255, 255);
    font-weight: 300;
    font-size: 20px;
    line-height: 50px;
`;



// WEBPACK FOOTER //
// ./src/Components/Screen/Proposal/ProposalBottom/ProposalBottomStyle.js